import * as React from 'react';
import { SVGProps } from 'react';

export const Module = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4454_84544)">
      <g opacity="0.2">
        <mask
          id="mask0_4454_84544"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="2"
          width="15"
          height="18"
        >
          <path
            d="M14 3.31079H1.25732V19H14V3.31079Z"
            fill="white"
            stroke="white"
            strokeWidth="0.8"
          />
        </mask>
        <g mask="url(#mask0_4454_84544)">
          <path
            d="M14 3.32151V8.95312L13.715 10.7374L11.8938 19H1.26788L1.25732 10.0891L1.50014 9.04421L2.58227 7.59746L6.21398 3.80912L7.73951 3.35902L11.0281 3.31079L14 3.32151Z"
            fill="#071114"
            stroke="#071114"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <path
        d="M16.7781 28.8169C14.0245 28.8169 11.378 28.0562 9.32611 26.6793C9.2029 26.599 9.17075 26.4329 9.25111 26.3097C9.33147 26.1865 9.49755 26.1543 9.62077 26.2347C11.5815 27.5526 14.1263 28.2812 16.7728 28.2812C19.4193 28.2812 21.9533 27.5526 23.9194 26.2347C24.0426 26.149 24.2087 26.1865 24.2891 26.3097C24.3694 26.4329 24.3373 26.599 24.2141 26.6793C22.1622 28.0562 19.5211 28.8169 16.7728 28.8169H16.7781Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M23.8497 28.8063C23.8497 28.8063 23.5174 29.0851 23.4906 29.0743C23.3513 29.0315 23.2709 28.8815 23.3138 28.7368L24.0103 26.5136L21.787 25.8171C21.6477 25.7742 21.5673 25.6242 21.6102 25.4796C21.653 25.3403 21.803 25.2599 21.9477 25.3028L24.4228 26.0796C24.5621 26.1225 24.6424 26.2725 24.5996 26.4171L23.8227 28.8922C23.7852 29.0047 23.5 29.0797 23.5656 29.0797L23.8497 28.8063Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M9.95209 29.0848C9.83959 29.0848 9.73244 29.0098 9.69494 28.8973L8.91813 26.4222C8.8967 26.3526 8.90206 26.2829 8.9342 26.2186C8.96635 26.1543 9.02528 26.1061 9.08957 26.0847L11.5646 25.3079C11.7039 25.265 11.8539 25.34 11.9022 25.4847C11.9504 25.6293 11.87 25.774 11.7254 25.8222L9.50208 26.5186L10.1985 28.7419C10.2414 28.8812 10.1664 29.0312 10.0217 29.0794C9.99495 29.0902 9.96816 29.0902 9.94138 29.0902L9.95209 29.0848Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M30.0686 17.9041C29.9401 17.9041 29.8276 17.813 29.8061 17.6844L29.3883 15.3486C29.3615 15.204 29.4579 15.0647 29.6025 15.0379C29.7472 15.0111 29.8865 15.1076 29.9133 15.2522L30.3311 17.588C30.3579 17.7326 30.2615 17.8719 30.1169 17.8987C30.1008 17.8987 30.0847 17.8987 30.0686 17.8987V17.9041Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M2.24305 22.8006C2.24305 22.8006 2.21091 22.8006 2.19484 22.8006C2.05019 22.7738 1.95376 22.6345 1.98054 22.4899L2.39841 20.1541C2.4252 20.0094 2.56449 19.913 2.70914 19.9398C2.85378 19.9666 2.95022 20.1058 2.92343 20.2505L2.50556 22.5863C2.48413 22.7149 2.37163 22.8059 2.24305 22.8059V22.8006Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M11.0721 22.8003C10.9435 22.8003 10.831 22.7092 10.8095 22.5807L10.3917 20.2449C10.3649 20.1002 10.4613 19.9609 10.606 19.9342C10.7506 19.9074 10.8899 20.0038 10.9167 20.1484L11.3346 22.4842C11.3613 22.6289 11.2649 22.7682 11.1203 22.795C11.1042 22.795 11.0881 22.795 11.0721 22.795V22.8003Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M12.0521 19.2648H1.26787C1.11786 19.2648 1 19.1469 1 18.9969V10.7895C1 9.67521 1.41251 8.60375 2.16789 7.77872L5.33942 4.31254C6.10016 3.4768 7.18769 3 8.31808 3H28.1991C29.3134 3 30.2188 3.91074 30.2188 5.02506V6.41261C30.2188 6.56261 30.1009 6.68047 29.9509 6.68047C29.8009 6.68047 29.683 6.56261 29.683 6.41261V5.02506C29.683 4.20539 29.0187 3.54109 28.1991 3.54109H8.31808C7.3377 3.54109 6.40017 3.9536 5.73586 4.67684L2.56433 8.14302C1.90003 8.86625 1.53573 9.80914 1.53573 10.7895V18.7291H11.7843V15.1343C11.7843 14.4057 11.1896 13.8057 10.4557 13.8057H4.79833C4.64833 13.8057 4.53047 13.6878 4.53047 13.5378V10.7895C4.53047 10.1842 4.03759 9.69128 3.43222 9.69128C3.28221 9.69128 3.16435 9.57342 3.16435 9.42341C3.16435 9.27341 3.28221 9.15555 3.43222 9.15555C4.33225 9.15555 5.0662 9.8895 5.0662 10.7895V13.27H10.4557C11.4843 13.27 12.32 14.1057 12.32 15.1343V18.9969C12.32 19.1469 12.2021 19.2648 12.0521 19.2648Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M14.179 9.48247C14.029 9.48247 13.9111 9.36461 13.9111 9.2146V4.64482C13.9111 4.49481 14.029 4.37695 14.179 4.37695C14.329 4.37695 14.4469 4.49481 14.4469 4.64482V9.2146C14.4469 9.36461 14.329 9.48247 14.179 9.48247Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M26.3461 9.67001H10.0491C9.89911 9.67001 9.78125 9.55215 9.78125 9.40214C9.78125 9.25214 9.89911 9.13428 10.0491 9.13428H26.3461C26.4961 9.13428 26.6139 9.25214 26.6139 9.40214C26.6139 9.55215 26.4961 9.67001 26.3461 9.67001Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M22.1346 9.55747C21.9846 9.55747 21.8667 9.43961 21.8667 9.28961V4.64482C21.8667 4.49481 21.9846 4.37695 22.1346 4.37695C22.2846 4.37695 22.4024 4.49481 22.4024 4.64482V9.28961C22.4024 9.43961 22.2846 9.55747 22.1346 9.55747Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M14.7098 14.2076C14.5598 14.2076 14.4419 14.0897 14.4419 13.9397C14.4419 13.7897 14.5598 13.6719 14.7098 13.6719H30.9585V8.57172C30.9585 8.06813 30.5513 7.66098 30.0477 7.66098H29.8549C29.3513 7.66098 28.9441 8.06813 28.9441 8.57172V11.7325C28.9441 11.8825 28.8263 12.0004 28.6763 12.0004H15.1116C14.9616 12.0004 14.8437 11.8825 14.8437 11.7325C14.8437 11.5825 14.9616 11.4647 15.1116 11.4647H28.4084V8.57172C28.4084 7.77348 29.0566 7.12524 29.8549 7.12524H30.0477C30.846 7.12524 31.4942 7.77348 31.4942 8.57172V13.8326C31.4942 14.0362 31.3281 14.1969 31.1246 14.1969H14.7098V14.2076Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M8.85406 8.81272C8.70405 8.81272 8.58619 8.69486 8.58619 8.54485V5.78048C8.58619 5.11617 8.07189 4.74116 7.88974 4.6608C7.75581 4.60187 7.69152 4.44115 7.75045 4.30722C7.80938 4.17329 7.96474 4.109 8.10403 4.16793C8.51119 4.34472 9.12192 4.92331 9.12192 5.77512V8.5395C9.12192 8.6895 9.00406 8.80736 8.85406 8.80736V8.81272Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M8.13089 10.2004L7.00586 12.0219"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M7.00569 12.2896C6.95747 12.2896 6.90926 12.2789 6.8664 12.2521C6.74318 12.1718 6.70032 12.011 6.78068 11.8825L7.90572 10.061C7.98608 9.93776 8.1468 9.8949 8.27537 9.97526C8.39859 10.0556 8.44145 10.2163 8.36109 10.3449L7.23605 12.1664C7.18784 12.2468 7.09676 12.295 7.00569 12.295V12.2896Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M7.00592 12.2895C6.85591 12.2895 6.73805 12.1716 6.73805 12.0216V7.68756C6.71662 6.96432 6.18625 6.56252 5.81659 6.51431C5.67195 6.49288 5.5648 6.35895 5.58623 6.2143C5.60766 6.06965 5.74159 5.96251 5.88624 5.98394C6.54519 6.06965 7.24164 6.7286 7.27378 7.6822V12.027C7.27378 12.177 7.15592 12.2948 7.00592 12.2948V12.2895Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M12.9791 15.3752C12.9791 15.3752 12.9416 15.3752 12.9255 15.3699C12.7809 15.3377 12.6898 15.1985 12.7166 15.0538L13.9113 9.4072C13.9434 9.26256 14.0881 9.17148 14.2273 9.19827C14.372 9.23041 14.4631 9.3697 14.4363 9.51435L13.2416 15.161C13.2148 15.2895 13.1023 15.3752 12.9791 15.3752Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
      <path
        d="M22.515 11.8073C22.3864 11.8073 22.2739 11.7162 22.2525 11.5877L21.8668 9.38581C21.84 9.24117 21.9364 9.10188 22.0864 9.07509C22.2311 9.0483 22.3704 9.15009 22.3971 9.29474L22.7829 11.4966C22.8097 11.6412 22.7132 11.7805 22.5632 11.8073C22.5471 11.8073 22.5311 11.8073 22.515 11.8073Z"
        fill="#071114"
        stroke="#071114"
        strokeWidth="0.8"
      />
    </g>
    <defs>
      <clipPath id="clip0_4454_84544">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default Module;
